import { useTellescopeInfiniteQuery } from "@tellescope/tanstack-query";

/**
 * The org's connected Stripe accounts, for the admin to pick from explicitly before product
 * search proceeds. There is no auto-select-when-there's-only-one — stripeKeyDetails labels are
 * client-managed and never auto-populated by the backend, so an org with keys but no details
 * still surfaces (with the raw key as its own label).
 */
export const useStripeAccounts = () => {
  const query = useTellescopeInfiniteQuery({
    model: "organizations",
    method: "getSome",
    request: {},
    select: (data) =>
      data.pages.flatMap((page) =>
        page.flatMap((org) => {
          const keys = org.stripePublicKeys ?? [];
          return keys.map((key) => ({
            key,
            title: org.stripeKeyDetails?.find((detail) => detail.key === key)?.title ?? key,
          }));
        })
      ),
    // Accounts feed a plain Select with no search affordance, so every page must be drained up
    // front — otherwise organizations beyond page 1 are silently unreachable in the selector.
    fetchAllPages: true,
  });

  return { accounts: query.data ?? [], isLoading: query.isLoading, error: query.error };
};
